module.exports = __webpack_public_path__ + "static/media/08_1.5ba9dc39.png";